import type { PricingRuleAdminInput, PricingRuleCommonInput } from '@hprofits/api/ad-group/types';
import type { CreatePricingRuleInput } from '@hprofits/api-client';
import { DEFAULT_CAMPAIGN_PRIORITY } from '@hprofits/shared';
import type { AdGroupId, CampaignGroupId, CreativeGroupId, TargetGroupId } from '@hprofits/shared/types';

import { DEFAULT_DELIVERY, DEFAULT_PRICING_MODEL, DEFAULT_ROOT_PRICE } from '../columns';

export type BuildPricingRuleCreatePayloadDeps = {
  adGroupId: AdGroupId;
  campaignId: CampaignGroupId;
  targetGroupId: TargetGroupId;
  creativeGroupId: CreativeGroupId;
  isAdmin: boolean;
};

type AdminCreatePricingRuleInput = { adGroupId: AdGroupId; campaignId: CampaignGroupId } & PricingRuleAdminInput;
type CommonCreatePricingRuleInput = { adGroupId: AdGroupId; campaignId: CampaignGroupId } & PricingRuleCommonInput;

const buildSettingsDefaults = () =>
  ({
    delivery: { modifier: 'manual', value: DEFAULT_DELIVERY },
    pricingModel: { modifier: 'manual', value: DEFAULT_PRICING_MODEL },
    bid: { modifier: 'manual', value: DEFAULT_ROOT_PRICE },
  }) as const;

export const buildPricingRuleCreatePayload = ({
  adGroupId,
  campaignId,
  targetGroupId,
  creativeGroupId,
  isAdmin,
}: BuildPricingRuleCreatePayloadDeps): CreatePricingRuleInput => {
  if (isAdmin) {
    const payload: AdminCreatePricingRuleInput = {
      adGroupId,
      campaignId,
      mode: 'calculated',
      targetGroupId,
      creativeGroupId,
      subRules: [],
      ...buildSettingsDefaults(),
      priority: DEFAULT_CAMPAIGN_PRIORITY,
      autoRotateIsEnabled: false, // FIXME: THIS MUST BE DONE ON SERVER-SIDE!!! The whole payload except ID's must be auto-created on server side!!!
    };
    return payload;
  }

  const payload: CommonCreatePricingRuleInput = {
    adGroupId,
    campaignId,
    mode: 'calculated',
    targetGroupId,
    creativeGroupId,
    subRules: [],
    ...buildSettingsDefaults(),
  };
  return payload;
};
